module.exports = __webpack_public_path__ + "img/02efd75c-db3e-4cac-8252-b34dd782c1ab.20decbd9.webp";